import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Table } from 'tdesign-react';

function VariablesTable({ variables }) {
  const columns = [
    {
      colKey: 'key',
      title: '变量key',
    },
    {
      colKey: 'keyName',
      title: '变量名',
    },
    {
      colKey: 'defaultValue',
      title: '变量值',
    },
  ];
  return (
    <Root>
      <Table
        rowKey='variableId'
        maxHeight={300}
        columns={columns}
        data={variables}
        pagination={{
          defaultCurrent: 1,
          total: variables.length,
          totalContent: true,
          showJumper: false,
          showPageNumber: false,
          showPageSize: false,
          showPreviousAndNextBtn: false,
        }}
      />
    </Root>
  );
}

export default connect((state) => ({
  variables: state.execRecord.variables,
}))(VariablesTable);

const Root = styled.div`
  .t-table th {
    background-color: white !important;
  }
`;
